<template>
  <div class="radio-group-container noselect">
    <div
      class="item shadow rounded-full opacity-70"
      v-for="option in options"
      :key="option.title"
      @click="
        select(option.value);
        $emit('input', selected);
      "
      :class="`${selected.includes(option.value) ? 'selected' : ''} ${
        option.strike_through ? 'strike_through' : ''
      } ${
        rounded ? 'circles' : ''
      }`"
    >
      <img v-if="option.img" :src="require(`../assets/${option.img}`)" alt="" />
      <span>{{ option.title }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CheckBoxesGroup",
  props: {
    options: {
      type: Array,
      required: true,
    },
    rounded: {
      type: Boolean,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selected: [],
    };
  },
  methods: {
    select(val) {
      if (!this.selected.includes(val)) {
        this.selected.push(val);
      } else {
        // Remove the selected
        let i = this.selected.indexOf(val);
        if (i !== -1) this.selected.splice(i, 1);
      }
    },
  },
  watch: {
    value: function (val) {
      this.selected = val;
    },
  },
};
</script>

<style lang="scss" scoped>
.strike_through{
        text-decoration-line: line-through
      }
.radio-group-container {
  width: 100%;
  height: max-content;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  row-gap: 10px;
  float: left;

  .selected {
    box-shadow: inset 0 0 0 1px #2f434c !important;
    opacity: 1 !important;
  }

  .circles {
    min-width: 38px;
    max-height: 38px;
  }

  .item {
    float: left;
    width: max-content;
    padding: 12px 15px;
    background-color: white;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 3px;
    cursor: pointer;

    img {
      height: auto;
      width: auto;
      max-height: 18px;
    }

    span {
      font-size: 14px;
      text-align: left;
      color: #2f434c;
    }
  }
}
</style>
